<template>
    <section class="w-full flex flex-col bg-gradient-to-br from-gray-100 to-blue-50">
        <div class="container mx-auto">
            <div class="px-4 sm:px-8 flex flex-row flex-wrap w-full pb-4 sm:pb-8">
                <div v-if="role == 'user'"
                    class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-8 mt-4 sm:mt-8">
                    <tile v-for="(item, index) in studentMenu" :key="index" :item="item"></tile>
                </div>
                <div v-if="role == 'partner'"
                    class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-8 mt-4 sm:mt-8">
                    <tile v-for="(item, index) in partnerMenu" :key="index" :item="item"></tile>
                </div>
                <div v-if="role == 'admin' || role == 'superadmin' || role == 'Viewer' || role == 'careercounselor'"
                    class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-8 mt-4 sm:mt-8">
                    <tile v-for="(item, index) in adminMenu" :key="index" :item="item"></tile>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import gql from 'graphql-tag';
import Tile from "../../components/shared/Tile.vue";
export default {
    name: "employment-index",
    components: {
        Tile,
    },
    data() {
        return {
            jobsCount: 0,
            error: null,
            studentMenu: [
                {
                    id: 1,
                    isActive: true,
                    isImage: false,
                    path: "/employment/job-opportunities",
                    title: "Job Opportunities",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12 text-ternary group-hover:text-white">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z" />
                        </svg>`,
                    image: "",
                    isNotificationNumber: 0,
                    popOverContent: `<div>To apply for jobs</div>`,
                    showPopOver: true,
                },
                {
                    id: 2,
                    isActive: true,
                    isImage: false,
                    path: "/employment-requests",
                    title: "Employment Requests",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12 text-ternary group-hover:text-white">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
                        </svg>`,
                    image: "",
                    isNotificationNumber: 0,
                    popOverContent: `<ul class="list-disc pl-4">
                                        <li>Add employment requests</li>
                                    </ul>`,
                    showPopOver: true,
                },
                {
                    id: 2,
                    isActive: false,
                    isImage: false,
                    path: "",
                    title: "Internship Request & Workplace",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12 text-ternary group-hover:text-white">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
                        </svg>`,
                    image: "",
                    isNotificationNumber: 0,
                    popOverContent: ``,
                    showPopOver: false,
                },
                {
                    id: 3,
                    isActive: false,
                    isImage: false,
                    path: "",
                    title: "Feedback",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12 text-ternary group-hover:text-white">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                        </svg>`,
                    image: "",
                    isNotificationNumber: 0,
                    popOverContent: ``,
                    showPopOver: false,
                },
            ],
            partnerMenu: [
                {
                    id: 2,
                    isActive: true,
                    isImage: false,
                    path: "/employment-requests",
                    title: "Employment Requests",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12 text-ternary group-hover:text-white">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
                        </svg>`,
                    image: "",
                    isNotificationNumber: 0,
                    popOverContent: `<ul class="list-disc pl-4">
                                        <li>View employment requests</li>
                                    </ul>`,
                    showPopOver: true,
                },
                {
                    id: 1,
                    isActive: true,
                    isImage: false,
                    path: "/jobs",
                    title: "Jobs",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12 text-ternary group-hover:text-white">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z" />
                        </svg>`,
                    image: "",
                    isNotificationNumber: 0,
                    popOverContent: `<ul class="list-disc pl-4">
                                        <li>Add Vacancy</li>
                                        <li>Edit Vacancy</li>
                                        <li>Delete Vacancy</li>
                                    </ul>`,
                    showPopOver: true,
                },
                {
                    id: 2,
                    isActive: true,
                    isImage: false,
                    path: "/employment/job-request-and-approval",
                    title: "Approvals Actions",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12 text-ternary group-hover:text-white">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 019 9v.375M10.125 2.25A3.375 3.375 0 0113.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 013.375 3.375M9 15l2.25 2.25L15 12" />
                            </svg>`,
                    image: "",
                    isNotificationNumber: 0,
                    popOverContent: `<ul class="list-disc pl-4">
                                        <li>Approve Job Application</li>
                                        <li>Reject Job Application</li>
                                    </ul>`,
                    showPopOver: true,
                },
                {
                    id: 3,
                    isActive: true,
                    isImage: true,
                    path: "/employment/booking-interviews",
                    title: "Booking Interviews",
                    icon: ``,
                    image: require('../../assets/images/employment/partner/img1.png'),
                    isNotificationNumber: 0,
                    popOverContent: ``,
                    showPopOver: false,
                },
            ],
            adminMenu: [
                {
                    id: 1,
                    isActive: true,
                    isImage: true,
                    path: "/partners",
                    title: "Employers",
                    icon: ``,
                    image: require('../../assets/images/icons/img3.png'),
                    isNotificationNumber: 0,
                    popOverContent: `<ul class="list-disc pl-4">
                                        <li>Approve / Reject Employer Applications</li>
                                    </ul>`,
                    showPopOver: true,
                },
                {
                    id: 2,
                    isActive: true,
                    isImage: false,
                    path: "/employment-requests",
                    title: "Employment Requests",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12 text-ternary group-hover:text-white">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
                        </svg>`,
                    image: "",
                    isNotificationNumber: 0,
                    popOverContent: `<ul class="list-disc pl-4">
                                        <li>View employment requests</li>
                                    </ul>`,
                    showPopOver: true,
                },
                {
                    id: 2,
                    isActive: true,
                    isImage: false,
                    path: "/jobs",
                    title: "Jobs",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12 text-ternary group-hover:text-white">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z" />
                        </svg>`,
                    image: "",
                    isNotificationNumber: 0,
                    popOverContent: `<ul class="list-disc pl-4">
                                        <li>View jobs created by partners</li>
                                    </ul>`,
                    showPopOver: true,
                },
                {
                    id: 3,
                    isActive: true,
                    isImage: false,
                    path: "/employment/job-request-and-approval",
                    title: "Approvals Actions",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12 text-ternary group-hover:text-white">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 019 9v.375M10.125 2.25A3.375 3.375 0 0113.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 013.375 3.375M9 15l2.25 2.25L15 12" />
                            </svg>`,
                    image: "",
                    isNotificationNumber: 0,
                    popOverContent: `<ul class="list-disc pl-4">
                                        <li>View jobs approved/rejected by partners</li>
                                    </ul>`,
                    showPopOver: true,
                },
                {
                    id: 4,
                    isActive: true,
                    isImage: true,
                    path: "/employment/booking-interviews",
                    title: "Booking Interviews",
                    icon: ``,
                    image: require('../../assets/images/employment/partner/img1.png'),
                    isNotificationNumber: 0,
                    popOverContent: `<ul class="list-disc pl-4">
                                        <li>View interviews created by partners</li>
                                    </ul>`,
                    showPopOver: true,
                },
                {
                    id: 5,
                    isActive: true,
                    isImage: true,
                    path: "/unemployed-graduates",
                    title: "Unemployed Graduates",
                    icon: ``,
                    image: require('../../assets/images/icons/img1.png'),
                    isNotificationNumber: 0,
                    popOverContent: `<ul class="list-disc pl-4">
                                        <li>Unemployed Graduates List</li>
                                        <li>Send Job Opportunity Email</li>
                                    </ul>`,
                    showPopOver: true,
                },
            ],
        };
    },
    computed: {
        role() {
            return this.$store.getters.role;
        },
        user_type() {
            return this.$store.getters.user_type;
        },
        entity() {
            return this.$store.getters.entity;
        },
        isItAlumniUser() {
            if (this.user_type == 'school_graduate' || this.user_type == 'college_graduate' || this.user_type == 'school_graduate_college_graduate') {
                return true;
            } else {
                return false;
            }
        },
        isItGraduatingUser() {
            if (this.user_type == 'school_graduating' || this.user_type == 'college_graduating' || this.user_type == 'school_graduate_college_graduating') {
                return true;
            } else {
                return false;
            }
        },
        isATS() {
            if (this.entity == 'ATHS' || this.entity == 'ATS') {
                return true;
            } else {
                return false;
            }
        },
    },
    created() {
        if (this.role == 'user') {
            this.fetchJobsCount();
        }
    },
    methods: {
        async fetchJobsCount() {

            const GET_JOBS_COUNT_QUERY = gql`
                query GetJobsCount($student_id: String) {
                    getJobsCount(student_id: $student_id) {
                        count
                        error
                        error_code
                        message
                    }
                }
            `;

            try {
                await this.$apollo.query({
                    query: GET_JOBS_COUNT_QUERY,
                    variables: {
                        student_id: this.$store.getters.student_id,
                    },
                    fetchPolicy: 'network-only',
                }).then((data) => {
                    if (data.data.getJobsCount.error) {
                        this.error = data.data.getJobsCount.message;
                    } else {
                        this.jobsCount = data.data.getJobsCount.count;
                        this.studentMenu[0].isNotificationNumber = this.jobsCount;
                    }
                }).catch((error) => {
                    this.error = error.message;
                })

            } catch (error) {
                this.error = error.message || "Please try again.";
            }
        },
    },
}
</script>

<style lang="scss" scoped></style>